module.exports = {
  name: 'booking-rate-list',
  listClass: 'rate-list-wrapper results',
  defaultLimit: 100,
  itemIndexes: 'synXisID'
}